import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { Router } from '@angular/router';
import { Pagination } from '../../../core/dto/pagination';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { SupplierService } from '../../../core/services/supplier.service';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';

@Component({
  selector: 'app-view-suppliers',
  templateUrl: './view-suppliers.component.html',
  styleUrls: ['./view-suppliers.component.scss'],
})
export class ViewSuppliersComponent implements OnInit {
  filterStatus: any;
  searchText: any;
  isDeleting = false;
  supplierData: any[] = []; // Initialize with dummy data
  breadcrumbs: any[] = [];
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  skeletonTableColumns: any[] = [
    'Supplier ID',
    'Supplier Name',
    'Mobile Number',
    'Email',
    'Number of Drivers',
    'Created Date',
    'Actions',
  ];
  loading = false;

  constructor(
    private router: Router,
    private supplierService: SupplierService,
  ) {}

  ngOnInit(): void {
    this.setBreadcrumbs();
    this.getPagedSuppliers();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedSuppliers();
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: `Suppliers`,
        route: '/admin/suppliers',
      },
    ];
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedSuppliers();
  }

  getPagedSuppliers(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
      },
    });
    this.supplierService.getSuppliersPaged(payload).then((res: any) => {
      this.loading = false;
      this.supplierData = res.data;
      this.pageSize.length = res.totalItems;
    });
  }

  search(): void {
    this.getPagedSuppliers();
  }

  resetSearch(): void {
    this.searchText = null;
    this.getPagedSuppliers();
  }

  navigateAddNew(): void {
    this.router.navigate(['admin/suppliers/add-edit']);
  }

  navigateToSingle(data: any): void {
    this.router.navigate([`admin/suppliers/${data._id}`]);
  }

  editNavigate(data: any): void {
    this.router.navigate([`admin/suppliers/add-edit/${data._id}`]);
  }

  deleteSupplier(data: any): void {
    this.supplierService.deleteSupplier(data).then((res) => {
      this.ngOnInit();
    });
  }

  hasAccessToPerformAction(type: string): boolean {
    if (type === 'update_delete') {
      return (
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'SUPPLIER_UPDATE',
        ) ||
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'SUPPLIER_DELETE',
        )
      );
    } else if (type === 'all') {
      return (
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'SUPPLIER_UPDATE',
        ) ||
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'SUPPLIER_DELETE',
        ) ||
        _.includes(
          localStorage.getItem(SETTINGS.USER_PERMISSIONS),
          'SUPPLIER_SINGLE_VIEW',
        )
      );
    } else {
      return true;
    }
  }

  checkPermissionsWithUserActiveStatus(data: any, permission: string): boolean {
    return (
      _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), permission) &&
      data.active
    );
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
}
